{
  "identities.messages.1010001": "تسجيل الدخول",
  "identities.messages.1010002": "تسجيل الدخول باستخدام {provider}",
  "identities.messages.1010003": "يرجى تأكيد هذا الإجراء من خلال التحقق من أنك أنت.",
  "identities.messages.1010004": "يرجى إكمال تحدي المصادقة الثاني.",
  "identities.messages.1010005": "تحقق",
  "identities.messages.1010006": "رمز المصادقة",
  "identities.messages.1010007": "رمز الاسترداد الاحتياطي",
  "identities.messages.1010008": "المتابعة باستخدام مفتاح الأجهزة",
  "identities.messages.1010009": "متابعة",
  "identities.messages.1010010": "متابعة",
  "identities.messages.1010011": "تسجيل الدخول باستخدام مفتاح الأجهزة",
  "identities.messages.1010012": "قم بتحضير جهاز WebAuthn الخاص بك (مثل مفتاح الأمان، ماسح القياسات الحيوية، ...) واضغط على متابعة.",
  "identities.messages.1010013": "متابعة",
  "identities.messages.1010014": "تم إرسال رمز إلى العنوان الذي قدمته. إذا لم تستلمه، يرجى التحقق من إملاء العنوان والمحاولة مرة أخرى.",
  "identities.messages.1010015": "إرسال رمز تسجيل الدخول",
  "identities.messages.1010016": "لقد حاولت تسجيل الدخول باستخدام \"{duplicateIdentifier}\"، ولكن هذا البريد الإلكتروني مستخدم بالفعل من قبل حساب آخر. قم بتسجيل الدخول إلى حسابك باستخدام أحد الخيارات أدناه لإضافة حسابك \"{duplicateIdentifier}\" في \"{provider}\" كطريقة أخرى لتسجيل الدخول.",
  "identities.messages.1010017": "تسجيل الدخول والربط",
  "identities.messages.1010018": "تأكيد مع {provider}",
  "identities.messages.1010019": "طلب رمز للمتابعة",
  "identities.messages.1010021": "تسجيل الدخول باستخدام مفتاح المرور",
  "identities.messages.1010022": "تسجيل الدخول باستخدام كلمة المرور",
  "identities.messages.1010023": "إرسال الرمز إلى {address}",
  "identities.messages.1040001": "التسجيل",
  "identities.messages.1040002": "التسجيل باستخدام {provider}",
  "identities.messages.1040003": "متابعة",
  "identities.messages.1040004": "التسجيل باستخدام مفتاح الأمان",
  "identities.messages.1040005": "تم إرسال رمز إلى العنوان (العناوين) التي قدمتها. إذا لم تستلم رسالة، تحقق من إملاء العنوان وأعد محاولة التسجيل.",
  "identities.messages.1040006": "إرسال رمز التسجيل",
  "identities.messages.1040007": "التسجيل باستخدام مفتاح المرور",
  "identities.messages.1040008": "العودة",
  "identities.messages.1040009": "يرجى اختيار بيانات اعتماد للمصادقة.",
  "identities.messages.1050001": "تم حفظ التغييرات الخاصة بك!",
  "identities.messages.1050002": "ربط {provider}",
  "identities.messages.1050003": "إلغاء ربط {provider}",
  "identities.messages.1050004": "إلغاء ربط تطبيق المصادقة TOTP",
  "identities.messages.1050005": "رمز QR لتطبيق المصادقة",
  "identities.messages.1050006": "{secret}",
  "identities.messages.1050007": "كشف رموز الاسترداد الاحتياطية",
  "identities.messages.1050008": "تمكين",
  "identities.messages.1050009": "{secret}",
  "identities.messages.1050010": "هذه هي رموز الاسترداد الاحتياطية الخاصة بك. يرجى الاحتفاظ بها في مكان آمن!",
  "identities.messages.1050011": "تأكيد رموز الاسترداد الاحتياطية",
  "identities.messages.1050012": "إضافة مفتاح أمان",
  "identities.messages.1050013": "اسم مفتاح الأمان",
  "identities.messages.1050014": "تم استخدام السر في {used_at, date, long}",
  "identities.messages.1050015": "{secrets_list}",
  "identities.messages.1050016": "تعطيل هذه الطريقة",
  "identities.messages.1050017": "سر المصادقة",
  "identities.messages.1050018": "إزالة مفتاح الأمان \"{display_name}\"",
  "identities.messages.1050019": "إضافة مفتاح مرور",
  "identities.messages.1050020": "إزالة مفتاح المرور \"{display_name}\"",
  "identities.messages.1060001": "لقد استعدت حسابك بنجاح. يرجى تغيير كلمة المرور الخاصة بك أو إعداد طريقة تسجيل دخول بديلة (مثل تسجيل الدخول الاجتماعي) خلال {privileged_session_expires_at_unix_until_minutes} دقيقة القادمة.",
  "identities.messages.1060002": "تم إرسال بريد إلكتروني يحتوي على رابط استرداد إلى عنوان البريد الإلكتروني الذي قدمته. إذا لم تستلم بريدًا إلكترونيًا، تحقق من إملاء العنوان وتأكد من استخدام العنوان الذي سجلت به.",
  "identities.messages.1060003": "تم إرسال بريد إلكتروني يحتوي على رمز استرداد إلى عنوان البريد الإلكتروني الذي قدمته. إذا لم تستلم بريدًا إلكترونيًا، تحقق من إملاء العنوان وتأكد من استخدام العنوان الذي سجلت به.",
  "identities.messages.1060004": "تم إرسال رمز استرداد إلى \"{masked_address}\". إذا لم تستلمه، تحقق من إملاء العنوان وتأكد من استخدام العنوان الذي سجلت به.",
  "identities.messages.1060005": "استعد الوصول إلى حسابك من خلال تقديم عنوان الاسترداد الكامل الخاص بك.",
  "identities.messages.1060006": "كيف تريد استعادة حسابك؟",
  "identities.messages.1060007": "العودة",
  "identities.messages.1070001": "كلمة المرور",
  "identities.messages.1070002": "{title}",
  "identities.messages.1070003": "حفظ",
  "identities.messages.1070004": "المعرف",
  "identities.messages.1070005": "إرسال",
  "identities.messages.1070006": "تحقق من الرمز",
  "identities.messages.1070007": "البريد الإلكتروني",
  "identities.messages.1070008": "إعادة إرسال الرمز",
  "identities.messages.1070009": "متابعة",
  "identities.messages.1070010": "رمز الاسترداد",
  "identities.messages.1070011": "رمز التحقق",
  "identities.messages.1070012": "رمز التسجيل",
  "identities.messages.1070013": "رمز تسجيل الدخول",
  "identities.messages.1070014": "تسجيل الدخول وربط بيانات الاعتماد",
  "identities.messages.1070015": "يرجى إكمال تحدي captcha للمتابعة.",
  "identities.messages.1070016": "عنوان الاسترداد",
  "identities.messages.1070017": "رقم الهاتف",
  "identities.messages.1080001": "تم إرسال بريد إلكتروني يحتوي على رابط التحقق إلى عنوان البريد الإلكتروني الذي قدمته. إذا لم تستلم بريدًا إلكترونيًا، تحقق من إملاء العنوان وتأكد من استخدام العنوان الذي سجلت به.",
  "identities.messages.1080002": "لقد تحققت من عنوان بريدك الإلكتروني بنجاح.",
  "identities.messages.1080003": "تم إرسال بريد إلكتروني يحتوي على رمز التحقق إلى عنوان البريد الإلكتروني الذي قدمته. إذا لم تستلم بريدًا إلكترونيًا، تحقق من إملاء العنوان وتأكد من استخدام العنوان الذي سجلت به.",
  "identities.messages.4000001": "{reason}",
  "identities.messages.4000002": "يرجى إدخال {property} والمحاولة مرة أخرى.",
  "identities.messages.4000003": "يجب أن يكون الطول >= {min_length}، ولكن الحصول على {actual_length}",
  "identities.messages.4000004": "لا يطابق النمط \"{pattern}\"",
  "identities.messages.4000005": "لا يمكن استخدام كلمة المرور لأن {reason}.",
  "identities.messages.4000006": "بيانات الاعتماد المقدمة غير صالحة، تحقق من الأخطاء الإملائية في كلمة المرور أو اسم المستخدم أو عنوان البريد الإلكتروني أو رقم الهاتف.",
  "identities.messages.4000007": "يوجد حساب بنفس المعرف (البريد الإلكتروني، الهاتف، اسم المستخدم، ...) بالفعل.",
  "identities.messages.4000008": "رمز المصادقة المقدم غير صالح، يرجى المحاولة مرة أخرى.",
  "identities.messages.4000009": "تعذر العثور على أي معرفات تسجيل دخول. هل نسيت تعيينها؟ قد يكون هذا بسبب خطأ في تكوين الخادم.",
  "identities.messages.4000010": "الحساب غير نشط بعد. هل نسيت التحقق من عنوان بريدك الإلكتروني؟",
  "identities.messages.4000011": "ليس لديك جهاز TOTP مُعد.",
  "identities.messages.4000012": "تم استخدام رمز الاسترداد الاحتياطي هذا بالفعل.",
  "identities.messages.4000013": "ليس لديك جهاز WebAuthn مُعد.",
  "identities.messages.4000014": "ليس لديك رموز استرداد احتياطية مُعدة.",
  "identities.messages.4000015": "هذا الحساب غير موجود أو ليس لديه مفتاح أمان مُعد.",
  "identities.messages.4000016": "رمز الاسترداد الاحتياطي غير صالح.",
  "identities.messages.4000017": "يجب أن يكون الطول <= {max_length}، ولكن الحصول على {actual_length}",
  "identities.messages.4000018": "يجب أن يكون >= {minimum} ولكن تم العثور على {actual}",
  "identities.messages.4000019": "يجب أن يكون > {minimum} ولكن تم العثور على {actual}",
  "identities.messages.4000020": "يجب أن يكون <= {maximum} ولكن تم العثور على {actual}",
  "identities.messages.4000021": "يجب أن يكون < {maximum} ولكن تم العثور على {actual}",
  "identities.messages.4000022": "{actual} ليس مضاعفًا لـ {base}",
  "identities.messages.4000023": "الحد الأقصى {max_items} عنصر مسموح، ولكن تم العثور على {actual_items} عنصر",
  "identities.messages.4000024": "الحد الأدنى {min_items} عنصر مسموح، ولكن تم العثور على {actual_items} عنصر",
  "identities.messages.4000025": "العناصر في الفهرس {index_a} و {index_b} متساوية",
  "identities.messages.4000026": "متوقع {allowed_types_list}، ولكن الحصول على {actual_type}",
  "identities.messages.4000027": "يوجد حساب بنفس المعرف (البريد الإلكتروني، الهاتف، اسم المستخدم، ...) بالفعل. يرجى تسجيل الدخول إلى حسابك الحالي لربط ملفك الاجتماعي.",
  "identities.messages.4000028": "لقد حاولت تسجيل الدخول باستخدام {credential_identifier_hint} المستخدم بالفعل من قبل حساب آخر. يمكنك تسجيل الدخول باستخدام {available_credential_types_list}. يمكنك تسجيل الدخول باستخدام أحد موفري تسجيل الدخول الاجتماعي التاليين: {available_oidc_providers_list}.",
  "identities.messages.4000029": "يجب أن يساوي الثابت {expected}",
  "identities.messages.4000030": "فشل الثابت",
  "identities.messages.4000031": "لا يمكن استخدام كلمة المرور لأنها مشابهة جدًا للمعرف.",
  "identities.messages.4000032": "يجب أن تكون كلمة المرور {min_length} حرفًا على الأقل، ولكن الحصول على {actual_length}.",
  "identities.messages.4000033": "يجب أن تكون كلمة المرور {max_length} حرفًا على الأكثر، ولكن الحصول على {actual_length}.",
  "identities.messages.4000034": "تم العثور على كلمة المرور في انتهاكات البيانات ويجب عدم استخدامها بعد الآن.",
  "identities.messages.4000035": "هذا الحساب غير موجود أو لم يتم إعداد تسجيل الدخول بالرمز.",
  "identities.messages.4000036": "السمات المقدمة لا تتطابق مع السمات المرتبطة سابقًا بهذا التدفق.",
  "identities.messages.4000037": "هذا الحساب غير موجود أو ليس لديه طريقة تسجيل دخول مُكوَّنة.",
  "identities.messages.4000038": "فشل التحقق من captcha، يرجى المحاولة مرة أخرى.",
  "identities.messages.4010001": "انتهت صلاحية التفاعل. يرجى المحاولة مرة أخرى.",
  "identities.messages.4010002": "تعذر العثور على استراتيجية لتسجيل دخولك. هل ملأت النموذج بشكل صحيح؟",
  "identities.messages.4010003": "تعذر العثور على استراتيجية لتسجيلك. هل ملأت النموذج بشكل صحيح؟",
  "identities.messages.4010004": "تعذر العثور على استراتيجية لتحديث إعداداتك. هل ملأت النموذج بشكل صحيح؟",
  "identities.messages.4010005": "تعذر العثور على استراتيجية لاستعادة حسابك. هل ملأت النموذج بشكل صحيح؟",
  "identities.messages.4010006": "تعذر العثور على استراتيجية للتحقق من حسابك. هل ملأت النموذج بشكل صحيح؟",
  "identities.messages.4010007": "تم إكمال الطلب بنجاح بالفعل ولا يمكن إعادة المحاولة.",
  "identities.messages.4010008": "رمز تسجيل الدخول غير صالح أو تم استخدامه بالفعل. يرجى المحاولة مرة أخرى.",
  "identities.messages.4010009": "بيانات الاعتماد المرتبطة لا تتطابق.",
  "identities.messages.4010010": "العنوان الذي أدخلته لا يتطابق مع أي عناوين معروفة في الحساب الحالي.",
  "identities.messages.4040001": "انتهت صلاحية التفاعل. يرجى المحاولة مرة أخرى.",
  "identities.messages.4040002": "تم إكمال الطلب بنجاح بالفعل ولا يمكن إعادة المحاولة.",
  "identities.messages.4040003": "رمز التسجيل غير صالح أو تم استخدامه بالفعل. يرجى المحاولة مرة أخرى.",
  "identities.messages.4050001": "انتهت صلاحية التفاعل. يرجى المحاولة مرة أخرى.",
  "identities.messages.4060001": "تم إكمال الطلب بنجاح بالفعل ولا يمكن إعادة المحاولة.",
  "identities.messages.4060002": "وصل تدفق الاسترداد إلى حالة فشل ويجب إعادة المحاولة.",
  "identities.messages.4060004": "رمز الاسترداد غير صالح أو تم استخدامه بالفعل. يرجى إعادة محاولة التدفق.",
  "identities.messages.4060005": "انتهت صلاحية التفاعل. يرجى المحاولة مرة أخرى.",
  "identities.messages.4060006": "رمز الاسترداد غير صالح أو تم استخدامه بالفعل. يرجى المحاولة مرة أخرى.",
  "identities.messages.4070001": "رمز التحقق غير صالح أو تم استخدامه بالفعل. يرجى إعادة محاولة التدفق.",
  "identities.messages.4070002": "تم إكمال الطلب بنجاح بالفعل ولا يمكن إعادة المحاولة.",
  "identities.messages.4070003": "وصل تدفق التحقق إلى حالة فشل ويجب إعادة المحاولة.",
  "identities.messages.4070005": "انتهت صلاحية التفاعل. يرجى المحاولة مرة أخرى.",
  "identities.messages.4070006": "رمز التحقق غير صالح أو تم استخدامه بالفعل. يرجى المحاولة مرة أخرى.",
  "identities.messages.5000001": "{reason}",
  "login.logout-button": "تسجيل الخروج",
  "login.registration-button": "التسجيل",
  "login.registration-label": "ليس لديك حساب؟",
  "login.title": "تسجيل الدخول",
  "login.subtitle": "تسجيل الدخول باستخدام {parts}",
  "login.title-aal2": "مصادقة العامل الثاني",
  "login.subtitle-aal2": "اختر طريقة لإكمال مصادقة العامل الثاني",
  "login.code.subtitle": "سيتم إرسال رمز التحقق عبر البريد الإلكتروني",
  "login.webauthn.subtitle": "يرجى تحضير جهاز WebAuthn الخاص بك",
  "login.totp.subtitle": "يرجى إدخال الرمز الذي تم إنشاؤه بواسطة تطبيق المصادقة الخاص بك",
  "login.lookup_secret.subtitle": "يرجى إدخال أحد رموز الاسترداد الاحتياطية المكونة من 8 أرقام",
  "login.title-refresh": "إعادة المصادقة",
  "login.subtitle-refresh": "أكد هويتك باستخدام {parts}",
  "login.2fa.go-back": "شيء ما لا يعمل؟",
  "login.2fa.go-back.link": "العودة",
  "login.2fa.method.go-back": "اختر طريقة أخرى",
  "recovery.title": "استعادة حسابك",
  "recovery.subtitle": "أدخل المعرف المرتبط بحسابك لتلقي رمز وصول لمرة واحدة",
  "registration.login-button": "تسجيل الدخول",
  "registration.login-label": "لديك حساب بالفعل؟",
  "registration.title": "تسجيل حساب",
  "registration.subtitle": "التسجيل باستخدام {parts}",
  "settings.navigation-back-button": "العودة",
  "settings.subtitle": "تحديث إعدادات حسابك",
  "settings.title": "إعدادات الحساب",
  "settings.password.title": "تغيير كلمة المرور",
  "settings.password.description": "تعديل كلمة المرور الخاصة بك",
  "settings.profile.title": "إعدادات الملف الشخصي",
  "settings.profile.description": "تحديث معلومات ملفك الشخصي",
  "settings.webauthn.title": "إدارة رموز الأجهزة",
  "settings.webauthn.description": "إدارة إعدادات رموز الأجهزة الخاصة بك",
  "settings.messages.toast-title.success": "تم تحديث الإعدادات",
  "settings.messages.toast-title.error": "تعذر تحديث الإعدادات",
  "verification.title": "التحقق من حسابك",
  "verification.subtitle": "أدخل عنوان البريد الإلكتروني المرتبط بحسابك للتحقق منه",
  "two-step.password.title": "كلمة المرور",
  "two-step.password.description": "أدخل كلمة المرور المرتبطة بحسابك",
  "two-step.code.title": "رمز البريد الإلكتروني",
  "two-step.code.description": "سيتم إرسال رمز التحقق إلى بريدك الإلكتروني",
  "two-step.webauthn.title": "مفتاح الأمان",
  "two-step.webauthn.description": "استخدم مفتاح الأمان الخاص بك للمصادقة",
  "two-step.passkey.title": "مفتاح المرور (موصى به)",
  "two-step.passkey.description": "استخدم جهازك للتعرف على بصمات الأصابع أو الوجه",
  "two-step.passkey.description.error": "تعذر تحميل المكتبات الضرورية لاستخدام مفتاح المرور الخاص بك. يرجى المحاولة مرة أخرى لاحقًا.",
  "two-step.totp.title": "استخدم تطبيق المصادقة الخاص بك (TOTP)",
  "two-step.totp.description": "استخدم رمزًا لمرة واحدة مكونًا من 6 أرقام من تطبيق المصادقة الخاص بك",
  "two-step.lookup_secret.title": "رمز الاسترداد الاحتياطي",
  "two-step.lookup_secret.description": "استخدم أحد رموز النسخ الاحتياطي المكونة من 8 أرقام للمصادقة",
  "input.placeholder": "أدخل {placeholder} الخاص بك",
  "card.header.parts.oidc": "موفر اجتماعي",
  "card.header.parts.password.registration": "{identifierLabel} الخاص بك وكلمة مرور",
  "card.header.parts.password.login": "{identifierLabel} الخاص بك وكلمة المرور",
  "card.header.parts.code": "رمز لمرة واحدة",
  "card.header.parts.passkey": "مفتاح مرور",
  "card.header.parts.webauthn": "مفتاح أمان",
  "card.header.parts.totp": "تطبيق المصادقة الخاص بك",
  "card.header.parts.lookup_secret": "رمز الاسترداد الاحتياطي",
  "card.header.parts.identifier-first": "{identifierLabel} الخاص بك",
  "misc.or": "أو",
  "forms.label.forgot-password": "نسيت كلمة المرور؟",
  "forms.label.recover-account": "استعادة الحساب",
  "settings.totp.title": "تطبيق المصادقة",
  "settings.totp.description": "أضف تطبيق مصادقة TOTP إلى حسابك لتحسين أمان حسابك. تطبيقات المصادقة الشائعة هي LastPass و Google Authenticator",
  "settings.totp.info.not-linked": "للتمكين، امسح رمز QR باستخدام المصادقة الخاصة بك وأدخل الرمز.",
  "settings.totp.info.linked": "لديك حاليًا تطبيق مصادقة متصل.",
  "settings.lookup_secret.title": "رموز الاسترداد الاحتياطية (العامل الثاني)",
  "settings.lookup_secret.description": "رموز الاسترداد هي نسخة احتياطية آمنة لـ 2FA، مما يسمح لك باستعادة الوصول إلى حسابك إذا فقدت جهاز 2FA الخاص بك.",
  "settings.oidc.title": "الحسابات المتصلة",
  "settings.oidc.description": "قم بتوصيل موفر تسجيل دخول اجتماعي بحسابك.",
  "settings.oidc.info": "يمكن استخدام الحسابات المتصلة من هؤلاء الموفرين لتسجيل الدخول إلى حسابك",
  "settings.webauthn.info": "تُستخدم رموز الأجهزة للمصادقة الثنائية أو كعامل أول مع مفاتيح المرور",
  "settings.passkey.title": "إدارة مفاتيح المرور",
  "settings.passkey.description": "إدارة إعدادات مفاتيح المرور الخاصة بك",
  "settings.passkey.info": "إدارة إعدادات مفاتيح المرور الخاصة بك",
  "card.footer.select-another-method": "حدد طريقة أخرى",
  "account-linking.title": "ربط الحساب",
  "property.password": "كلمة المرور",
  "property.email": "البريد الإلكتروني",
  "property.phone": "الهاتف",
  "property.username": "اسم المستخدم",
  "property.identifier": "المعرف",
  "property.code": "الرمز",
  "property.recovery_address": "عنوان الاسترداد",
  "consent.title": "تفويض {party}",
  "consent.subtitle": "يريد تطبيق طرف ثالث الوصول إلى المعلومات المرتبطة بحسابك {identifier}.",
  "consent.scope.openid.title": "الهوية",
  "consent.scope.openid.description": "يسمح للتطبيق بالتحقق من هويتك. هذا مطلوب للمصادقة وتجربة تسجيل دخول موثوقة.",
  "consent.scope.offline_access.title": "الوصول دون اتصال",
  "consent.scope.offline_access.description": "يسمح لهذا التطبيق بإبقائك مسجلاً حتى عندما لا تستخدمه بنشاط.",
  "consent.scope.profile.title": "معلومات الملف الشخصي",
  "consent.scope.profile.description": "يسمح بالوصول إلى تفاصيل ملفك الشخصي الأساسية، بما في ذلك اسم المستخدم والاسم الأول والأخير.",
  "consent.scope.email.title": "عنوان البريد الإلكتروني",
  "consent.scope.email.description": "استرداد عنوان بريدك الإلكتروني وحالة التحقق منه.",
  "consent.scope.address.title": "العنوان الفعلي",
  "consent.scope.address.description": "الوصول إلى عنوانك البريدي.",
  "consent.scope.phone.title": "رقم الهاتف",
  "consent.scope.phone.description": "استرداد رقم هاتفك وحالة التحقق منه.",
  "error.title.what-happened": "ماذا حدث؟",
  "error.title.what-can-i-do": "ماذا يمكنني أن أفعل؟",
  "error.instructions": "يرجى المحاولة مرة أخرى في غضون بضع دقائق أو الاتصال بمشغل الموقع.",
  "error.footer.text": "عند الإبلاغ عن هذا الخطأ، يرجى تضمين المعلومات التالية:",
  "error.footer.copy": "نسخ",
  "error.action.go-back": "العودة",
  "identities.messages.4000039": "يجب أن تكون كلمة المرور الجديدة مختلفة عن كلمة المرور القديمة.",
  "identities.messages.4000040": "أدخل عنوان بريد إلكتروني صالح",
  "identities.messages.4000041": "أدخل رقم هاتف صالح",
  "captcha.error": "فشل التحقق الأمني. يرجى المحاولة مرة أخرى لاحقًا. إذا استمرت المشكلة، يرجى الاتصال بالدعم.",
  "identities.messages.5000002": "لا توجد طرق مصادقة متاحة. يرجى التواصل مع مسؤول النظام.",
  "identities.messages.4010011": "تم تعطيل هذا الحساب. يرجى التواصل مع فريق الدعم للحصول على المساعدة.",
  "identities.messages.1070018": "البريد الإلكتروني أو رقم الهاتف",
  "identities.messages.1080004": "تم إرسال رسالة نصية تحتوي على رمز التحقق إلى رقم الهاتف الذي قدمته. إذا لم تتلق الرسالة النصية، فتحقق من صحة كتابة الرقم وتأكد من استخدام الرقم الذي قمت بالتسجيل به.",
  "identities.messages.1080005": "لقد تم التحقق من رقم هاتفك بنجاح.",
  "identities.messages.5000003": "تتطلب مؤسستك استخدام نظام تسجيل الدخول الموحد (SSO)، ولكن لم يتم إعداد أي مزود خدمة لتوفير هذا النظام. يرجى التواصل مع مسؤول النظام.",
  "identities.messages.1010024": "سجّل الدخول باستخدام مفتاح أمان مادي.",
  "identities.messages.1010025": "تم إرسال رمز إلى عنوانك. إذا لم تستلمه، يرجى المحاولة مرة أخرى.",
  "identities.messages.4000042": "لم يتم إعداد أي جهاز مصادقة للأجهزة لديك.",
  "identities.messages.4000043": "تسجيل الدخول عبر الإنترنت باستخدام بيانات الاعتماد المقدمة غير صالح، يرجى المحاولة مرة أخرى.",
  "identities.messages.4000044": "التوقيع الرقمي الخاص بـ DeviceAuthn الذي تم تقديمه غير صالح.",
  "identities.messages.4050002": "يمكنك تغيير عنوان واحد فقط في كل مرة. يرجى تحديث كل عنوان على حدة."
}
